import { useMemo } from "react";
import { useSelector } from "react-redux";

import { makeGetSectionNumber } from "seneca-common/features/course/state";

import RowNumber from "../RowNumber";

type Props = {
  courseId: string;
  sectionId: string;
};

export default function SectionRowNumber({ courseId, sectionId }: Props) {
  const getSectionNumber = useMemo(
    () => makeGetSectionNumber(courseId, sectionId),
    [courseId, sectionId]
  );
  const number = useSelector(getSectionNumber);

  return <RowNumber>{number}</RowNumber>;
}
